// murmurhash2 via https://gist.github.com/raycmorgan/588423

function hashString(str) {
  return hash(str, str.length).toString(36);
}

function hash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

var pa = function fa(ha) {
  function V(b, c, d, h, l) {
    for (var a = 0, f = 0, m = 0, e = 0, r, q, k, w = 0, B = 0, C = 0, z = 0, n = r = 0, G = 0, p = 0, y = q = 0, L = 0, t = 0, D = d.length, M = D - 1, v, g = "", u = "", S = "", N = "", H; p < D;) {
      k = d.charCodeAt(p);if (0 === f + e + m + a) {
        if (p === M && (0 < q && (g = g.replace(P, "")), 0 < g.trim().length)) {
          switch (k) {case 32:case 9:case 59:case 13:case 10:
              break;default:
              g += d.charAt(p);}k = 59;
        }if (1 === y) switch (k) {case 123:case 44:
            y = 0;break;case 9:case 13:case 10:case 32:
            break;default:
            p--, k = 59;}switch (k) {case 123:
            g = g.trim();r = g.charCodeAt(0);z = 1;for (t = ++p; p < D;) {
              k = d.charCodeAt(p);switch (k) {case 123:
                  z++;break;case 125:
                  z--;}if (0 === z) break;p++;
            }n = d.substring(t, p);0 === r && (r = (g = g.replace(qa, "").trim()).charCodeAt(0));switch (r) {case 64:
                0 < q && (g = g.replace(P, ""));q = g.charCodeAt(1);switch (q) {case 100:case 109:case 115:
                    k = c;break;default:
                    k = W;}n = V(c, k, n, q, l + 1);t = n.length;0 < X && 0 === t && (t = g.length);0 < E && (k = ia(W, g, L), H = O(3, n, k, c, I, A, t, q, l), g = k.join(""), void 0 !== H && 0 === (t = (n = H.trim()).length) && (q = 0, n = ""));if (0 < t) switch (q) {case 115:
                    g = g.replace(ra, sa);case 100:case 109:
                    n = g + "{" + n + "}";break;case 107:
                    g = g.replace(ta, "$1 $2" + (0 < Q ? T : ""));n = g + "{" + n + "}";n = 1 === x || 2 === x && U("@" + n, 3) ? "@-webkit-" + n + "@" + n : "@" + n;break;default:
                    n = g + n;} else n = "";break;default:
                n = V(c, ia(c, g, L), n, h, l + 1);}S += n;n = L = q = G = y = r = 0;g = "";k = d.charCodeAt(++p);break;case 125:case 59:
            g = (0 < q ? g.replace(P, "") : g).trim();if (1 < (t = g.length)) switch (0 === G && (r = g.charCodeAt(0), 45 === r || 96 < r && 123 > r) && (t = (g = g.replace(" ", ":")).length), 0 < E && void 0 !== (H = O(1, g, c, b, I, A, u.length, h, l)) && 0 === (t = (g = H.trim()).length) && (g = "\x00\x00"), r = g.charCodeAt(0), q = g.charCodeAt(1), r + q) {case 0:
                break;case 169:case 163:
                N += g + d.charAt(p);break;default:
                58 !== g.charCodeAt(t - 1) && (u += ja(g, r, q, g.charCodeAt(2)));}L = q = G = y = r = 0;g = "";k = d.charCodeAt(++p);}
      }switch (k) {case 13:case 10:
          if (0 === f + e + m + a + ka) switch (C) {case 41:case 39:case 34:case 64:case 126:case 62:case 42:case 43:case 47:case 45:case 58:case 44:case 59:case 123:case 125:
              break;default:
              0 < G && (y = 1);}47 === f && (f = 0);0 < E * la && O(0, g, c, b, I, A, u.length, h, l);A = 1;I++;break;case 59:case 125:
          if (0 === f + e + m + a) {
            A++;break;
          }default:
          A++;v = d.charAt(p);switch (k) {case 9:case 32:
              if (0 === e + a) switch (w) {case 44:case 58:case 9:case 32:
                  v = "";break;default:
                  32 !== k && (v = " ");}break;case 0:
              v = "\\0";break;case 12:
              v = "\\f";break;case 11:
              v = "\\v";break;case 38:
              0 === e + f + a && 0 < F && (q = L = 1, v = "\f" + v);break;case 108:
              if (0 === e + f + a + J && 0 < G) switch (p - G) {case 2:
                  112 === w && 58 === d.charCodeAt(p - 3) && (J = w);case 8:
                  111 === B && (J = B);}break;case 58:
              0 === e + f + a && (G = p);break;case 44:
              0 === f + m + e + a && (q = 1, v += "\r");break;case 34:
              0 === f && (e = e === k ? 0 : 0 === e ? k : e, p === M && (M++, D++));break;case 39:
              0 === f && (e = e === k ? 0 : 0 === e ? k : e, p === M && (M++, D++));break;case 91:
              0 === e + f + m && a++;break;case 93:
              0 === e + f + m && a--;break;case 41:
              0 === e + f + a && (p === M && (M++, D++), m--);break;case 40:
              if (0 === e + f + a) {
                if (0 === r) switch (2 * w + 3 * B) {case 533:
                    break;default:
                    z = 0, r = 1;}m++;
              }break;case 64:
              0 === f + m + e + a + G + n && (n = 1);break;case 42:case 47:
              if (!(0 < e + a + m)) switch (f) {case 0:
                  switch (2 * k + 3 * d.charCodeAt(p + 1)) {case 235:
                      f = 47;break;case 220:
                      t = p, f = 42;}break;case 42:
                  47 === k && 42 === w && (33 === d.charCodeAt(t + 2) && (u += d.substring(t, p + 1)), v = "", f = 0);}}if (0 === f) {
            if (0 === F + e + a + n && 107 !== h && 59 !== k) switch (k) {case 44:case 126:case 62:case 43:case 41:case 40:
                if (0 === r) {
                  switch (w) {case 9:case 32:case 10:case 13:
                      v += "\x00";break;default:
                      v = "\x00" + v + (44 === k ? "" : "\x00");}q = 1;
                } else switch (k) {case 40:
                    r = ++z;break;case 41:
                    0 === (r = --z) && (q = 1, v += "\x00");}break;case 32:
                switch (w) {case 0:case 123:case 125:case 59:case 44:case 12:case 9:case 32:case 10:case 13:
                    break;default:
                    0 === r && (q = 1, v += "\x00");}}g += v;32 !== k && (C = k);
          }}B = w;w = k;p++;
    }t = u.length;0 < X && 0 === t && 0 === S.length && 0 === c[0].length === !1 && (109 !== h || 1 === c.length && (0 < F ? K : R) === c[0]) && (t = c.join(",").length + 2);if (0 < t) {
      if (0 === F && 107 !== h) {
        d = 0;a = c.length;for (f = Array(a); d < a; ++d) {
          w = c[d].split(ua);B = "";C = 0;for (D = w.length; C < D; ++C) {
            if (!(0 === (z = (e = w[C]).length) && 1 < D)) {
              p = B.charCodeAt(B.length - 1);L = e.charCodeAt(0);m = "";if (0 !== C) switch (p) {case 42:case 126:case 62:case 43:case 32:case 40:
                  break;default:
                  m = " ";}switch (L) {case 38:
                  e = m + K;case 126:case 62:case 43:case 32:case 41:case 40:
                  break;case 91:
                  e = m + e + K;break;case 58:
                  switch (2 * e.charCodeAt(1) + 3 * e.charCodeAt(2)) {case 530:
                      if (0 < Y) {
                        e = m + e.substring(8, z - 1);break;
                      }default:
                      if (1 > C || 1 > w[C - 1].length) e = m + K + e;}break;case 44:
                  m = "";default:
                  e = 1 < z && 0 < e.indexOf(":") ? m + e.replace(va, "$1" + K + "$2") : m + e + K;}B += e;
            }
          }f[d] = B.replace(P, "").trim();
        }c = f;
      }k = c;if (0 < E && (H = O(2, u, k, b, I, A, t, h, l), void 0 !== H && 0 === (u = H).length)) return N + u + S;u = k.join(",") + "{" + u + "}";if (0 !== x * J) {
        2 !== x || U(u, 2) || (J = 0);switch (J) {case 111:
            u = u.replace(wa, ":-moz-$1") + u;break;case 112:
            u = u.replace(Z, "::-webkit-input-$1") + u.replace(Z, "::-moz-$1") + u.replace(Z, ":-ms-input-$1") + u;}J = 0;
      }
    }return N + u + S;
  }function ia(b, c, d) {
    var h = c.trim().split(xa);c = h;var l = h.length,
        a = b.length;switch (a) {case 0:case 1:
        var f = 0;for (b = 0 === a ? "" : b[0] + " "; f < l; ++f) {
          c[f] = ma(b, c[f], d, a).trim();
        }break;default:
        var m = f = 0;for (c = []; f < l; ++f) {
          for (var e = 0; e < a; ++e) {
            c[m++] = ma(b[e] + " ", h[f], d, a).trim();
          }
        }}return c;
  }function ma(b, c, d, h) {
    var l = c.charCodeAt(0);33 > l && (l = (c = c.trim()).charCodeAt(0));switch (l) {case 38:
        switch (F + h) {case 0:case 1:
            if (0 === b.trim().length) break;default:
            return c.replace(N, "$1" + b.trim());}break;case 58:
        switch (c.charCodeAt(1)) {case 103:
            if (0 < Y && 0 < F) return c.replace(ya, "$1").replace(N, "$1" + R);break;default:
            return b.trim() + c;}default:
        if (0 < d * F && 0 < c.indexOf("\f")) return c.replace(N, (58 === b.charCodeAt(0) ? "" : "$1") + b.trim());}return b + c;
  }function ja(b, c, d, h) {
    var l = 0,
        a = b + ";";c = 2 * c + 3 * d + 4 * h;if (944 === c) {
      l = a.length;b = a.indexOf(":", 9) + 1;d = a.substring(0, b).trim();h = a.substring(b, l - 1).trim();switch (a.charCodeAt(9) * Q) {case 0:
          break;case 45:
          if (110 !== a.charCodeAt(10)) break;default:
          for (a = h.split((h = "", za)), b = c = 0, l = a.length; c < l; b = 0, ++c) {
            for (var f = a[c], m = f.split(Aa); f = m[b];) {
              var e = f.charCodeAt(0);if (1 === Q && (64 < e && 90 > e || 96 < e && 123 > e || 95 === e || 45 === e && 45 !== f.charCodeAt(1))) switch (isNaN(parseFloat(f)) + (-1 !== f.indexOf("("))) {case 1:
                  switch (f) {case "infinite":case "alternate":case "backwards":case "running":case "normal":case "forwards":case "both":case "none":case "linear":case "ease":case "ease-in":case "ease-out":case "ease-in-out":case "paused":case "reverse":case "alternate-reverse":case "inherit":case "initial":case "unset":case "step-start":case "step-end":
                      break;
                    default:
                      f += T;}}m[b++] = f;
            }h += (0 === c ? "" : ",") + m.join(" ");
          }}h = d + h + ";";return 1 === x || 2 === x && U(h, 1) ? "-webkit-" + h + h : h;
    }if (0 === x || 2 === x && !U(a, 1)) return a;switch (c) {case 1015:
        return 45 === a.charCodeAt(9) ? "-webkit-" + a + a : a;case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;case 969:case 942:
        return "-webkit-" + a + a;case 978:
        return "-webkit-" + a + "-moz-" + a + a;case 1019:case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;case 883:
        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;case 932:
        return "-webkit-" + a + "-ms-" + a + a;case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;case 1023:
        if (99 !== a.charCodeAt(8)) break;b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;case 1005:
        return Ba.test(a) ? a.replace(na, ":-webkit-") + a.replace(na, ":-moz-") + a : a;case 1E3:
        b = a.substring(13).trim();l = b.indexOf("-") + 1;switch (b.charCodeAt(0) + b.charCodeAt(l)) {case 226:
            b = a.replace(aa, "tb");break;case 232:
            b = a.replace(aa, "tb-rl");break;case 220:
            b = a.replace(aa, "lr");break;default:
            return a;}return "-webkit-" + a + "-ms-" + b + a;case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;case 975:
        l = (a = b).length - 10;b = (33 === a.charCodeAt(l) ? a.substring(0, l) : a).substring(b.indexOf(":", 7) + 1).trim();switch (c = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {case 203:
            if (111 > b.charCodeAt(8)) break;case 115:
            a = a.replace(b, "-webkit-" + b) + ";" + a;break;case 207:case 102:
            a = a.replace(b, "-webkit-" + (102 < c ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;}return a + ";";case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {case 105:
            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(Ca, "") + a;default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "") + a;}break;case 953:
        if (0 < (l = a.indexOf("-content", 9)) && 109 === a.charCodeAt(l - 3) && 45 !== a.charCodeAt(l - 4)) return b = a.substring(l - 3), "width:-webkit-" + b + "width:-moz-" + b + "width:" + b;break;case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(Da, "$1-webkit-$2") + a;}return a;
  }function U(b, c) {
    var d = b.indexOf(1 === c ? ":" : "{"),
        h = b.substring(0, 3 !== c ? d : 10);d = b.substring(d + 1, b.length - 1);return ba(2 !== c ? h : h.replace(Ea, "$1"), d, c);
  }function sa(b, c) {
    var d = ja(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));return d !== c + ";" ? d.replace(Fa, " or ($1)").substring(4) : "(" + c + ")";
  }function O(b, c, d, h, l, a, f, m, e) {
    for (var r = 0, q = c, k; r < E; ++r) {
      switch (k = ca[r].call(y, b, q, d, h, l, a, f, m, e)) {case void 0:case !1:case !0:case null:
          break;default:
          q = k;}
    }switch (q) {case void 0:case !1:case !0:case null:case c:
        break;default:
        return q;}
  }function da(b) {
    switch (b) {case void 0:case null:
        E = ca.length = 0;break;default:
        switch (b.constructor) {case Array:
            for (var c = 0, d = b.length; c < d; ++c) {
              da(b[c]);
            }break;case Function:
            ca[E++] = b;break;case Boolean:
            la = !!b | 0;}}return da;
  }function ea(b) {
    for (var c in b) {
      var d = b[c];switch (c) {case "keyframe":
          Q = d | 0;break;case "global":
          Y = d | 0;break;case "cascade":
          F = d | 0;break;case "compress":
          oa = d | 0;break;case "semicolon":
          ka = d | 0;break;case "preserve":
          X = d | 0;break;case "prefix":
          ba = null, d ? "function" !== typeof d ? x = 1 : (x = 2, ba = d) : x = 0;}
    }return ea;
  }function y(b, c) {
    if (void 0 !== this && this.constructor === y) return fa(b);var d = b,
        h = d.charCodeAt(0);33 > h && (h = (d = d.trim()).charCodeAt(0));0 < Q && (T = d.replace(Ga, 91 === h ? "" : "-"));h = 1;1 === F ? R = d : K = d;d = [R];if (0 < E) {
      var l = O(-1, c, d, d, I, A, 0, 0, 0);void 0 !== l && "string" === typeof l && (c = l);
    }var a = V(W, d, c, 0, 0);0 < E && (l = O(-2, a, d, d, I, A, a.length, 0, 0), void 0 !== l && "string" !== typeof (a = l) && (h = 0));K = R = T = "";J = 0;A = I = 1;return 0 === oa * h ? a : a.replace(P, "").replace(Ha, "").replace(Ia, "$1").replace(Ja, "$1").replace(Ka, " ");
  }var qa = /^\0+/g,
      P = /[\0\r\f]/g,
      na = /: */g,
      Ba = /zoo|gra/,
      Da = /([,: ])(transform)/g,
      za = /,+\s*(?![^(]*[)])/g,
      Aa = / +\s*(?![^(]*[)])/g,
      ua = / *[\0] */g,
      xa = /,\r+?/g,
      N = /([\t\r\n ])*\f?&/g,
      ya = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
      Ga = /\W+/g,
      ta = /@(k\w+)\s*(\S*)\s*/,
      Z = /::(place)/g,
      wa = /:(read-only)/g,
      Ha = /\s+(?=[{\];=:>])/g,
      Ia = /([[}=:>])\s+/g,
      Ja = /(\{[^{]+?);(?=\})/g,
      Ka = /\s{2,}/g,
      va = /([^\(])(:+) */g,
      aa = /[svh]\w+-[tblr]{2}/,
      ra = /\(\s*([^]*?)\s*\)/g,
      Fa = /([^]*?);/g,
      Ca = /-self|flex-/g,
      Ea = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      A = 1,
      I = 1,
      J = 0,
      F = 1,
      x = 1,
      Y = 1,
      oa = 0,
      ka = 0,
      X = 0,
      W = [],
      ca = [],
      E = 0,
      ba = null,
      la = 0,
      Q = 1,
      T = "",
      K = "",
      R = "";y.use = da;y.set = ea;void 0 !== ha && ea(ha);return y;
};

//  weak
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var unitless = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineClamp: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,

  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

export { memoize, unitless, hashString, pa as Stylis };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/emotion-utils/dist/index.es.js
// module id = 25
// module chunks = 0